import React from "react";
import { } from "react-router-dom";

import Maps from '../../Attendance/map';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";


interface IProps {
  company?: any;
}

class WorkplaceMap extends React.Component<IProps> {
  render() {
    return (this.props.company?.id ?
      <>
        <Maps companySpecific companyId={this.props.company?.id} editable />
      </>
      : <></>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    company: state.user.company,
  };
};
export default connect(mapStateToProps)(withTranslation()(WorkplaceMap as any) as any);
